const toNameLabel = ({ id, name }) => name || String(id);

const toIdNameLabel = ({ id, name }) => (name ? `${id} - ${name}` : String(id));

/*
 * The API sends the target names inside `targets` (GAP-1520); non-event campaigns have no
 * targets. Top-level lists, which the GLO-98 contract asked for, win if the BE adds them.
 */
const targetsOf = (data, key) => data[key] || (data.targets && data.targets[key]) || [];

/**
 * Maps a GET /api/campaigns item to a Campaigns grid row.
 *
 * Dates stay as the API sends them, local date-times without an offset, so the grid formats
 * them as stored instead of shifting them to another timezone.
 */
export default function normalizeCampaign(data) {
    return {
        campaignId: data.id,
        campaignName: data.name || '',
        description: data.description || '',
        active: data.active === true,
        level: data.level || '',
        campaignType: data.type || '',
        countries: data.countries || [],
        events: targetsOf(data, 'events').map(toNameLabel),
        attractions: targetsOf(data, 'attractions').map(toIdNameLabel),
        venues: targetsOf(data, 'venues').map(toIdNameLabel),
        startDate: data.startDate || null,
        endDate: data.endDate || null,
        createdBy: data.createdBy || '',
    };
}
